class Requirements {
	/**
	 * Creates new channel requirements.
	 * @param {Object} requirements - The requirements for the channel.
	 * @param {string[]} [requirements.countries] - The countries that the channel is available for.
	 */
	constructor({ countries }) {
		this.countries = countries;
	}

	/**
	 * Checks if the channel requirements are met by the given shop.
	 * @param {import('@nearst/shop-data/types').Shop} shop - The shop to check the requirements for.
	 * @returns {boolean} Whether the channel requirements are met.
	 */
	evaluate(shop) {
		if (this.countries && !this.countries.includes(shop.country)) {
			return false;
		}

		return true;
	}
}

module.exports = Requirements;
